import { render, staticRenderFns } from "./zhipaisiji.vue?vue&type=template&id=53140084&scoped=true&"
import script from "./zhipaisiji.vue?vue&type=script&lang=js&"
export * from "./zhipaisiji.vue?vue&type=script&lang=js&"
import style0 from "./zhipaisiji.vue?vue&type=style&index=0&id=53140084&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53140084",
  null
  
)

export default component.exports